import React, { Component } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { DisplayFormikState } from "../../utils/helper";
import { DatePicker } from "antd";
import { Collapse } from "reactstrap";
import style from "./CreatesNotes.module.css";
import api from "../../utils/Api";
import moment from "moment";
import ttmLoader from "../../assets/images/ttm-loader.gif";
import { connect } from "react-redux";
import {
  fetchNotesListing,
  fetchInitialNotesDataListing,
  saveNotes,
  deleteNotes,
} from "../../redux";
import swal from "sweetalert";
import * as Yup from "yup";

function dateFormatter(cell) {
  if (!cell) {
    return "";
  }
  return `${
    moment(cell).format("YYYY-MM-DD")
      ? moment(cell).format("YYYY-MM-DD")
      : moment(cell).format("YYYY-MM-DD")
  }`;
}

const Model = {
  heading: "",
  message: "",
  recurring: 0,
  recipient_id: "",
  related_party_id: "",
  start_date: "",
  end_date: "",
  frequency: "Daily",
  hobbies: "",
  interest: "",
  isNotesOpen: false,
};

export class CreatesNotes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      model: Model,
      recipientDropDwn: [],
      contactsDropDwn: [],
      notes: [],
      successMessage: "",
      errorMessage: "",
      isSubmitted: false,
      isLoading: false,
      isNotesLoading: false,
    };
  }

  componentDidMount() {
    this.props.fetchNotesListing();
    this.props.fetchInitialNotesDataListing();
  }

  handleChange = (event) => {
    event.persist();
    const val = event.target.value;
    const name = event.target.name;
    this.setState(
      {
        model: {
          ...this.state.model,
          [name]: val,
        },
      },
      () => this.removeErrors()
    );
  };

  handleCheckbox = (event) => {
    event.persist();
    const val = event.target.checked;
    const name = event.target.name;
    this.setState(
      {
        model: {
          ...this.state.model,
          [name]: val ? 1 : 0,
        },
      },
      () => this.removeErrors()
    );
  };

  removeErrors = () => {
    if (this.state.isSubmitted) {
      if (
        this.state.model.heading !== "" &&
        this.state.model.message !== "" &&
        ((this.state.model.recurring === 1 &&
          this.state.model.start_date !== "" &&
          this.state.model.end_date != "" &&
          this.state.model.frequency != "") ||
          this.state.model.recurring === 0) &&
        ((this.state.model.related_party_id != "" &&
          this.state.model.hobbies != "" &&
          this.state.model.interest != "") ||
          this.state.model.related_party_id == "")
      ) {
        this.setState({
          errorMessage: "",
        });
      } else {
        this.setState({
          errorMessage: "Please filled out all mandatory fields",
        });
      }
    }
  };

  handleChangeStartDate = (date) => {
    const end = this.state.end_date;

    // if(moment(date).format('YYYY-MM-DD') > moment(end).format('YYYY-MM-DD')){
    //   this.setState({
    //     errorMessage: "Please select start date smaller than end date!",
    //   });
    // }
    this.setState(
      {
        model: {
          ...this.state.model,
          start_date: date,
          errorMessage: "",
        },
      },
      () => this.removeErrors()
    );
  };

  handleChangeEndDate = (date) => {
    const start = this.state.start_date;
    // if(moment(start).format('YYYY-MM-DD') > moment(date).format('YYYY-MM-DD')){
    //   this.setState({
    //     errorMessage: "Please select end date greater than start date!",
    //   });
    // }

    this.setState(
      {
        model: {
          ...this.state.model,
          end_date: date,
        },
        errorMessage: "",
      },
      () => this.removeErrors()
    );
  };

  handleSubmit = async () => {
    this.setState({
      isSubmitted: true,
    });
    if (
      this.state.model.heading == "" ||
      this.state.model.message == "" ||
      (this.state.model.recurring === 1 &&
        (this.state.model.start_date == "" ||
          this.state.model.end_date == "" ||
          this.state.model.frequency == "")) ||
      (this.state.model.related_party_id &&
        (this.state.model.hobbies == "" || this.state.model.interest == ""))
    ) {
      this.setState({
        errorMessage: "Please filled out all mandatory fields",
      });
    } else {
      // if(moment(this.state.model.start_date).format('YYYY-MM-DD') >
      // moment(this.state.model.end_date).format('YYYY-MM-DD')){
      //   this.setState({
      //     errorMessage: "Please select end date greater than start date!",
      //   });
      //   return false;
      // }
      this.setState({
        isLoading: true,
      });

      let payload = {
        heading: this.state.model.heading,
        message: this.state.model.message,
        recurring: this.state.model.recurring,
      };

      if (this.state.model.recipient_id) {
        payload.recipient_id = this.state.model.recipient_id;
      }

      if (this.state.model.recurring === 1) {
        payload.start_date = moment(this.state.model.start_date).format(
          "YYYY-MM-DD"
        );
        payload.end_date = moment(this.state.model.end_date).format(
          "YYYY-MM-DD"
        );
        payload.frequency = this.state.model.frequency;
      }

      if (this.state.model.related_party_id) {
        payload.related_party_id = this.state.model.related_party_id;
        payload.hobbies = this.state.model.hobbies;
        payload.interest = this.state.model.interest;
      }

      //Api call
      await this.props.saveNotes(payload);

      if (this.props.saveNotesData.successMessage) {
        this.setState({
          isLoading: false,
          model: Model,
          successMessage: this.props.saveNotesData.successMessage,
          errorMessage: "",
          isSubmitted: false,
        });

        setTimeout(() => {
          this.setState({
            successMessage: "",
          });
        }, 2000);

        this.props.fetchNotesListing();
      } else if (this.props.saveNotesData.errorMessage) {
        this.setState({
          isLoading: false,
          isSubmitted: false,
          errorMessage: this.props.saveNotesData.errorMessage,
        });

        setTimeout(() => {
          this.setState({
            errorMessage: "",
          });
        }, 2000);
      }
    }
  };

  handleDeleteNote = async (noteId) => {
    const shouldDelete = await swal("Are you sure you want to delete this?", {
      className: "logout-swal-modal",
      buttons: ["Cancel", "Yes"],
    });
    if (shouldDelete && noteId) {
      await this.props.deleteNotes(noteId);
      if (
        this.props.deleteNotesData &&
        this.props.deleteNotesData.successMessage
      ) {
        this.props.fetchNotesListing();
      }
    }
  };

  getRelatedPartyName = (id) => {
    const notesDropDwnData = this.props.notesDropDwnData.initialNotesData;
    let obj =
      notesDropDwnData &&
      notesDropDwnData.relatedParty &&
      notesDropDwnData.relatedParty.length > 0 &&
      notesDropDwnData.relatedParty.find(
        (item) => item.related_party_id === parseInt(id)
      );
    return obj && obj.related_party_name
      ? obj.related_party_name
      : "Not Available";
  };

  getRecipientName = (id) => {
    const notesDropDwnData = this.props.notesDropDwnData.initialNotesData;
    let obj =
      notesDropDwnData &&
      notesDropDwnData.recipients &&
      notesDropDwnData.recipients.length > 0 &&
      notesDropDwnData.recipients.find(
        (item) => item.recipient_id === parseInt(id)
      );
    return obj && obj.recipient_name ? obj.recipient_name : "Not Available";
  };

  toggleNotes = () => {
    this.setState({
      isNotesOpen: !this.state.isNotesOpen,
    });
  };

  render() {
    const notesList = this.props.notesListData.notesList;
    const notesDropDwnData = this.props.notesDropDwnData.initialNotesData;

    const recipientDropDwnData =
      notesDropDwnData &&
      notesDropDwnData.recipients &&
      notesDropDwnData.recipients.length > 0 &&
      notesDropDwnData.recipients.map((element, index) => (
        <option key={index} value={element.recipient_id}>
          {element.recipient_name}
        </option>
      ));

    const contactsDropDwnData =
      notesDropDwnData &&
      notesDropDwnData.relatedParty &&
      notesDropDwnData.relatedParty.length > 0 &&
      notesDropDwnData.relatedParty.map((element, index) => (
        <option key={index} value={element.related_party_id}>
          {element.related_party_name}
        </option>
      ));

    return (
      <div>
        <div className={`card ${style.creatsNotesCard}`}>
          <div
            className={`card-header ${style.createsNotesHeader}`}
            onClick={this.toggleNotes}
          >
            <h4>Create Note</h4>
            {this.state.isNotesOpen ? (
              <i className="fa fa-angle-up" aria-hidden="true"></i>
            ) : (
              <i className="fa fa-angle-down" aria-hidden="true"></i>
            )}
          </div>
          <Collapse isOpen={this.state.isNotesOpen}>
            <hr className={style.divider} />
            <div className="card-body">
              <Formik>
                <Form>
                  <div className="row form-group">
                    <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
                      <label>
                        Heading{" "}
                        <span className="mandatory">
                          <small>*</small>
                        </span>
                      </label>
                      <Field
                        name="heading"
                        placeholder="Heading"
                        className={`form-control`}
                        onChange={this.handleChange}
                        value={this.state.model.heading}
                      />
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
                      <label>Reciepient (Optional)</label>
                      <Field
                        name="recipient_id"
                        as="select"
                        placeholder="Recipient"
                        className="form-control"
                        value={this.state.model.recipient_id}
                        onChange={this.handleChange}
                      >
                        <option value="">Select Receipient</option>
                        {recipientDropDwnData}
                      </Field>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
                      <label>Contacts (Optional)</label>
                      <Field
                        name="related_party_id"
                        as="select"
                        placeholder="Contact (Optional)"
                        className="form-control"
                        value={this.state.model.related_party_id}
                        onChange={this.handleChange}
                      >
                        <option value="">Select Contact</option>
                        {contactsDropDwnData}
                      </Field>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
                      <div
                        className={`custom-control custom-checkbox ${style.recurringWrapper}`}
                      >
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id="recurring"
                          name="recurring"
                          checked={this.state.model.recurring === 1}
                          onChange={this.handleCheckbox}
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="recurring"
                        >
                          Recurring
                        </label>
                      </div>
                    </div>
                    {this.state.model.recurring !== 0 && (
                      <React.Fragment>
                        <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
                          <label>
                            {" "}
                            Start Date{" "}
                            <span className="mandatory">
                              <small>*</small>
                            </span>
                          </label>
                          <DatePicker
                            name="start_date"
                            onChange={this.handleChangeStartDate}
                            placeholder="Start Date"
                            className={`form-control `}
                            disabledDate={(d) =>
                              !d || d.isAfter(this.state.model.end_date)
                            }
                            value={this.state.model.start_date}
                          />
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
                          <label>
                            {" "}
                            End Date{" "}
                            <span className="mandatory">
                              <small>*</small>
                            </span>
                          </label>
                          <DatePicker
                            name="end_date"
                            onChange={this.handleChangeEndDate}
                            placeholder="End Date"
                            className="form-control"
                            disabledDate={(d) =>
                              !d || d.isBefore(this.state.model.start_date)
                            }
                            value={this.state.model.end_date}
                          />
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
                          <label>
                            Frequency{" "}
                            <span className="mandatory">
                              <small>*</small>
                            </span>
                          </label>
                          <Field
                            name="frequency"
                            as="select"
                            placeholder="Frequency"
                            className="form-control"
                            value={this.state.model.frequency}
                            onChange={this.handleChange}
                          >
                            <option value="Daily">Daily</option>
                            <option value="Weekly">Weekly</option>
                            <option value="Monthly">Monthly</option>
                            <option value="Yearly">Yearly</option>
                          </Field>
                        </div>
                      </React.Fragment>
                    )}
                  </div>
                  {this.state.model.related_party_id && (
                    <div className="row">
                      <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
                        <label>
                          Hobbies{" "}
                          <span className="mandatory">
                            <small>*</small>
                          </span>
                        </label>
                        <Field
                          name="hobbies"
                          placeholder="Hobbies"
                          className="form-control"
                          onChange={this.handleChange}
                          value={this.state.model.hobbies}
                        />
                      </div>

                      <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
                        <label>
                          Interests{" "}
                          <span className="mandatory">
                            <small>*</small>
                          </span>
                        </label>
                        <Field
                          name="interest"
                          placeholder="Interests"
                          className="form-control"
                          onChange={this.handleChange}
                          value={this.state.model.interest}
                        />
                      </div>
                    </div>
                  )}
                  <div className="row">
                    <div className="col-md-9">
                      <label>
                        Message{" "}
                        <span className="mandatory">
                          <small>*</small>
                        </span>
                      </label>
                      <Field
                        component="textarea"
                        name="message"
                        placeholder="Message"
                        className="form-control"
                        value={this.state.model.message}
                        onChange={this.handleChange}
                      />
                    </div>
                    <div className="col-md-3 mob-save-btn-wrapper">
                      <button
                        type="button"
                        onClick={this.handleSubmit}
                        className={style.saveNotesBtn}
                      >
                        Save
                      </button>
                    </div>
                    <div className="col-md-12">
                      {this.props.saveNotesData.loading ? (
                        <div className={style.loadingWrapper}>
                          <img
                            src={ttmLoader}
                            alt="loader"
                            className={style.loading}
                          />
                        </div>
                      ) : (
                        <div>
                          {this.state.successMessage && (
                            <p className={style.successMessage}>
                              {this.state.successMessage}
                            </p>
                          )}
                          {this.state.errorMessage && (
                            <p className={style.errorMessage}>
                              {this.state.errorMessage}
                            </p>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </Form>
                {/* )} */}
              </Formik>
              {/* /> */}
            </div>
            <div className={`card-footer ${style.createsNotesFooter}`}>
              <div className={style.viewNotesHeading}>
                <p>View Notes</p>
                <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
              </div>
              <hr />

              <div className={style.notesViewListWrapper}>
                <div className={`row ${style.notesListHeight}`}>
                  {notesList &&
                    notesList.length > 0 &&
                    notesList.map(
                      (element, index) =>
                        element.heading &&
                        element.message && (
                          <div key={index} class="col-lg-12">
                            <div class="d-flex flex-column flex-sm-row">
                              <div class={`row ${style.notesListHeightRow}`}>
                                <div class="col-12">
                                  <div class={style.NoteList}>
                                    <div class={`row ${style.notesListRow}`}>
                                      <div class="col-xl-6">
                                        <div
                                          class={
                                            style.viewInnerNotesListHeading
                                          }
                                        >
                                          <p>{element.heading}</p>
                                        </div>
                                      </div>
                                      <div class="col-xl-6 text-xl-right">
                                        {element.recurring === 1 && (
                                          <div class={style.notesInforWrapper}>
                                            <p>
                                              <b>Date : </b>
                                              {`${dateFormatter(
                                                element.start_date
                                              )} - ${dateFormatter(
                                                element.end_date
                                              )} (${element.frequency})`}
                                            </p>
                                          </div>
                                        )}
                                      </div>
                                      <div class="col-lg-6 col-xl-7">
                                        {element.recipient_id && (
                                          <div class={style.notesInforWrapper}>
                                            <p>
                                              <b>Receipient : </b>{" "}
                                              {this.getRecipientName(
                                                element.recipient_id
                                              )}
                                            </p>
                                          </div>
                                        )}
                                      </div>
                                      <div class="col-lg-6 col-xl-5 text-xl-right">
                                        {element.related_party_id && (
                                          <div class={style.notesInforWrapper}>
                                            <p>
                                              <b>Contact : </b>{" "}
                                              {this.getRelatedPartyName(
                                                element.related_party_id
                                              )}
                                            </p>
                                          </div>
                                        )}
                                      </div>
                                      <div class="col-lg-6 col-xl-7">
                                        {element.related_party_id && (
                                          <div class={style.notesInforWrapper}>
                                            <p>
                                              <b>Hobbies : </b>{" "}
                                              {element.hobbies}{" "}
                                            </p>
                                          </div>
                                        )}
                                      </div>
                                      <div class="col-lg-6 col-xl-5 text-xl-right">
                                        {element.related_party_id && (
                                          <div class={style.notesInforWrapper}>
                                            <p>
                                              <b>Interests : </b>{" "}
                                              {element.interest}
                                            </p>
                                          </div>
                                        )}
                                      </div>
                                      <div class="col-lg-12">
                                        <div class={style.notesInforWrapper}>
                                          <p>
                                            <b>Message : </b>
                                            {element.message}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div title="Delete Note"
                                class={`${style.DeleteIcon} mt-sm-2`}
                                onClick={() =>
                                  this.handleDeleteNote(
                                    element.dashboard_notes_id
                                  )
                                }
                              >
                                <i class="fa fa-trash" aria-hidden="true"></i>
                              </div>
                            </div>
                            <hr />
                          </div>
                        )
                    )}
                  {this.props.notesListData.loading && (
                    <div className="col-md-12">
                      <div className={style.loadingWrapper}>
                        <img src={ttmLoader} alt="loader" className={style.loading} />
                      </div>
                    </div>
                  )}
                  {!this.props.notesListData.loading && notesList.length === 0 && (
                    <div className={`col-md-12 ${style.noDataText}`}>
                      <p>No notes found!</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Collapse>
        </div>
      </div>
    );
  }
}

// export default Users;
const mapStateToProps = (state) => {
  return {
    notesListData: state.notesList,
    notesDropDwnData: state.initialNotesData,
    saveNotesData: state.saveNotes,
    deleteNotesData: state.deleteNotes,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchInitialNotesDataListing: () =>
      dispatch(fetchInitialNotesDataListing()),
    fetchNotesListing: () => dispatch(fetchNotesListing()),
    saveNotes: (payload) => dispatch(saveNotes(payload)),
    deleteNotes: (noteId) => dispatch(deleteNotes(noteId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreatesNotes);
